import { ReactNode, useCallback, useState } from 'react'

import PlainModal, {
  PlainModalContent,
  PlainModalFooter,
  PlainModalHeader,
  HandleModalDisplayed,
} from 'app/common/ui-next/plain-modal'

import ControlsBar from 'app/common/ui-next/controls-bar'
import PlainButton from 'app/common/ui-next/plain-button'

import { DietFoodTypesCheckBoxes } from './DietFoodTypesCheckBoxes'
import { DietFoodTypeId, DietFoodType } from 'app/dataTypes/org/dietFoodTypes'
import { OrgId } from 'app/dataTypes/org'
import { useDietFoodTypes } from 'app/dataProviders/dietFoodTypes/hooks'


type Props = {
  orgId: OrgId
  dietFoodTypesUsed: Array<DietFoodType>
  onSubmit: (ids: Array<DietFoodTypeId>) => Promise<boolean>
  children: (toggle: HandleModalDisplayed) => ReactNode
}

export const AddRemoveDietFoodTypes = ({ orgId, dietFoodTypesUsed, onSubmit, children }: Props) => {
  const { data: dietFoodTypesList, loading } = useDietFoodTypes()

  const [saving, setSaving] = useState(false)

  const handleSubmit = useCallback(async (form: HTMLFormElement) => {
    const formData = new FormData(form)
    const dietFoodTypes = formData.getAll('dietFoodTypes') as Array<DietFoodTypeId>
    setSaving(true)
    const res = await onSubmit(dietFoodTypes)
    setSaving(false)
    return res
  }, [onSubmit])

  return (
    <PlainModal
      formId="addRemoveCategory"
      controlBy={children}
      onSubmit={handleSubmit}
    >
      <PlainModalHeader>{'Редактирование списка диетического питания'}</PlainModalHeader>

      <PlainModalContent paddingFree>
        <DietFoodTypesCheckBoxes
          dietFoodTypesList={dietFoodTypesList}
          dietFoodTypesUsed={dietFoodTypesUsed}
          disabled={saving}
        />
      </PlainModalContent>

      <PlainModalFooter>
        {toggleModal => (
          <ControlsBar right>
            <PlainButton outline onClick={toggleModal}>
              {'Отмена'}
            </PlainButton>
            <PlainButton type="submit" disabled={loading || saving}>
              {saving
                ? 'Применение...'
                : 'Применить'}
            </PlainButton>
          </ControlsBar>
        )}
      </PlainModalFooter>
    </PlainModal>
  )
}

